import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MachineCenterCard } from "../MachineCenterCard";
import { Grid } from "@mui/material";
import { ISortableMachineCenterCard } from "./ProductionLineAccordionInterfaces";

export function SortableMachineCenterCard({
    id,
    machineCenter,
    handleCardOnClick,
    handleClusterEditModalOpen,
    setEditableCluster,
    handleOnClickDelete,
    handleOnClickDuplicate,
    refetch,
}: ISortableMachineCenterCard) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <Grid item xs={3} ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <MachineCenterCard
                handleCardOnClick={handleCardOnClick}
                handleOnClickDelete={handleOnClickDelete}
                handleOnClickDuplicate={handleOnClickDuplicate}
                machineCenter={machineCenter}
                handleClusterEditModalOpen={handleClusterEditModalOpen}
                setEditableCluster={setEditableCluster}
                refetch={refetch}
            />
        </Grid>
    );
}
